module.exports = __webpack_public_path__ + "img/Norm Asidoz - Stand Alanı Banner.3fe7a583.jpg";